import { fillArray } from 'src/helpers/fillArray'

import {
  COLUMN_COUNT,
  ROW_COUNT,
} from 'src/features/SkeletonLoadingContacts/constants'

export const useSkeletonLoadingContacts = (tableCount: number) => {
  const tables = fillArray(tableCount)
  const headers = fillArray(COLUMN_COUNT)
  const fields = fillArray(ROW_COUNT)

  return {
    tables,
    headers,
    fields,
  }
}
